module.exports = __webpack_public_path__ + "static/media/twitter_icon.fe33a29d.svg";